import validate from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/auth.global.ts";
import secure_45route_45global from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/secure-route.global.ts";
import manifest_45route_45rule from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  secure_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  guest: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/guest.ts"),
  permission: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/permission.ts"),
  redirect: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/redirect.ts"),
  "signin-compat": () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/middleware/signin-compat.ts"),
  "sidebase-auth": () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}